var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGeminiLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 16,
    viewBox: "0 0 78 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gemini-logo",
    clipPath: "url(#clip0_278_286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.0457 8.77173H30.2064V10.8047C29.5277 11.2 28.6066 11.4447 27.7147 11.4447C25.4654 11.4447 23.9529 10.0329 23.9529 7.91526C23.9529 5.7882 25.446 4.35761 27.6565 4.35761C28.849 4.35761 29.8089 4.70584 30.6814 5.43996L30.8075 5.54349L31.7188 4.13173L31.6219 4.05643C30.5166 3.13408 29.0914 2.63525 27.6371 2.65408C26.0956 2.65408 24.6994 3.14349 23.7008 4.03761C22.6343 4.9882 22.072 6.32467 22.072 7.89643C22.072 10.9647 24.3601 13.1105 27.6371 13.1105C29.1399 13.1105 30.982 12.5458 32.0097 11.7741L32.0679 11.7364V7.16231H27.0554V8.77173H27.0457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34.2687 12.9882H42.4709V11.3694H36.0526V8.54585H41.3753V6.92703H36.0526V4.43291H42.4709V2.81409H34.2687V12.9882Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M50.2368 7.57644L46.1648 2.81409H44.5263V12.9882H46.3781V5.74115L50.0138 10.0047H50.4501L54.0859 5.74115V12.9882H55.9377V2.81409H54.3185L50.2368 7.57644Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M60.5138 2.81409H58.662V12.9882H60.5138V2.81409Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M71.0817 10.0706L64.867 2.86115L64.8185 2.81409H63.2285V12.9882H65.0803V5.75997L71.3047 12.9317L71.3532 12.9882H72.9238V2.81409H71.0817V10.0706Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M77.5 2.81409H75.6482V12.9882H77.5V2.81409Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M11.2715 0C8.3629 0.0188235 5.92938 2.14588 5.59974 4.95059C2.45846 5.28 0.199462 8.00941 0.538797 11.0494C0.849046 13.8635 3.29226 16 6.21054 16C9.11913 15.9812 11.5623 13.8541 11.8823 11.0494C15.0139 10.72 17.2826 7.99059 16.9432 4.94118C16.633 2.13647 14.1898 0 11.2715 0ZM15.6441 6.16471C15.3532 8.03765 13.8407 9.49647 11.9211 9.78823V6.16471H15.6441ZM1.83797 9.83529C2.12882 7.96235 3.64129 6.49412 5.56096 6.21176V9.82588L1.83797 9.83529ZM10.5831 11.0871C10.2244 13.4306 7.98478 15.0494 5.57065 14.7106C3.64129 14.4376 2.12882 12.96 1.83797 11.0871H10.5831ZM10.6316 6.16471V9.82588H6.85043V6.16471H10.6316ZM15.6441 4.91294H6.89891C7.25763 2.56941 9.49725 0.950588 11.9114 1.28941C13.8407 1.57176 15.3532 3.04 15.6441 4.91294Z",
    fill: "#26DDF9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_278_286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeminiLogo);
export default __webpack_public_path__ + "static/media/gemini-logo.c71330126699cd7ec8987afc844bd7cc.svg";
export { ForwardRef as ReactComponent };